import { useLocation } from "react-router-dom";

export const Footer = () => {
  const location = useLocation();
  const currentYear = new Date().getFullYear();
  const isUserRolesPage = location.pathname.includes("/user-roles");

  return (
    <footer
      style={{
        background: "#000",
        textAlign: "center",
        padding: isUserRolesPage ? "3px 10px 5px 10px" : "10px",
        zIndex: 1201,
        flexShrink: 0,
      }}
    >
      <p style={{
        margin: 0,
        fontSize: isUserRolesPage ? "13px" : "15px",
        fontWeight: "600",
        color: '#fff'
      }}>
        &copy; {currentYear} The Coca-Cola Company. All rights reserved.
      </p>
    </footer>
  );
};